import { EstateWorkItemStatus, EstateWorkItemSubStatus } from 'queries';

export const getEstateWorkItemSubStatusOptions = (_estateWorkItemStatus: EstateWorkItemStatus) => {
  const estateWorkIteSubStatusOptions = [
    {
      label: 'Not Started',
      value: EstateWorkItemSubStatus.NotStarted,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress',
      value: EstateWorkItemSubStatus.InProgress,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: bank inquiry',
      value: EstateWorkItemSubStatus.InProgressBankInquiry,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: insurance inquiry',
      value: EstateWorkItemSubStatus.InProgressInsuranceInquiry,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: printing',
      value: EstateWorkItemSubStatus.InProgressPrinting,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: Waiting on Requested Client Info',
      value: EstateWorkItemSubStatus.InProgressWaitingOnClientInfo,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: waiting on client (signature)',
      value: EstateWorkItemSubStatus.InProgressWaitingOnClientSignature,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'In Progress: waiting on institution',
      value: EstateWorkItemSubStatus.InProgressWaitingOnInstitution,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'Under Review',
      value: EstateWorkItemSubStatus.UnderReview,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'Preparing Paperwork',
      value: EstateWorkItemSubStatus.PreparingPaperwork,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'Stale',
      value: EstateWorkItemSubStatus.Stale,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.Completed,
    },
    {
      label: 'Completed',
      value: EstateWorkItemSubStatus.Completed,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.AssignedReady,
    },
    {
      label: 'Closed',
      value: EstateWorkItemSubStatus.Closed,
      // isDisabled: estateWorkItemStatus === EstateWorkItemStatus.AssignedReady,
    },
    {
      label: 'Auto Gen (In Progress)',
      value: EstateWorkItemSubStatus.AutoGenerationInProgress,
    },
    {
      label: 'Auto Gen (Template Needed)',
      value: EstateWorkItemSubStatus.AutoGenerationTemplateNeeded,
    },
    {
      label: 'Auto Gen (Awaiting Signature)',
      value: EstateWorkItemSubStatus.AutoGenerationAwaitingSignature,
    },
    {
      label: 'Auto Gen (Ready to Print)',
      value: EstateWorkItemSubStatus.AutoGenerationReadyToPrint,
    },
    {
      label: 'Auto Gen (Completed)',
      value: EstateWorkItemSubStatus.AutoGenerationCompleted,
    },
  ];

  return estateWorkIteSubStatusOptions;
};
